import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  InMemoryCache,
} from "@noom/hive-core";
import { createAuthLink } from "@noom/hive-auth";
import { appConfig } from "src/config";
import { getAnonymousClientAuthorizationHeader } from "./utils";

const httpLink = new HttpLink({
  uri: appConfig.GRAPHQL_URL,
});

const getMiddleware = () => {
  return new ApolloLink((operation, forward) => {
    // Logged-out client only: use the anonymous client token.
    const authorizationHeader = getAnonymousClientAuthorizationHeader();
    operation.setContext(({ headers = {} }) => ({
      headers: {
        ...headers,
        ...authorizationHeader,
      },
    }));

    return forward(operation);
  });
};

const authLink = createAuthLink({ ApolloLink });

export const apolloClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: authLink.concat(httpLink),
});

export const apolloClientLoggedOutToken = new ApolloClient({
  cache: new InMemoryCache(),
  link: getMiddleware().concat(httpLink),
});
